import { IconGraphic } from '@design-system/components/atoms/icon/entities/icon.types';

export function getVectorProps(graphic: IconGraphic, fillColor: string): { [key: string]: string } {
  return {
    mask: graphic.maskId ?? null,
    fill: graphic.fill ?? (!graphic.stroke?.fillIsDisabled ? fillColor : null),
    stroke: graphic.stroke?.strokeDefault ? fillColor : null,
    'stroke-width': graphic.stroke?.width ?? null,
  }
}
